import { render, staticRenderFns } from "./publication_checkboxes.vue?vue&type=template&id=b42c4a9c&lang=pug"
import script from "./publication_checkboxes.vue?vue&type=script&lang=js"
export * from "./publication_checkboxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports